//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ReidColposcopicIndex",
  data() {
    return {
      form: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "湿疣样或小乳头样轮廓，模糊醋酸白色上皮，边缘呈云絮状或羽毛状，成角状，粗糙的病变，卫星状病变与醋酸白色上皮延伸超过移行带。" },
        { value: "1", name: "病变轮廓光滑，直而规整，边缘锐利。" },
        { value: "2", name: "边缘呈卷曲状，病变区域内可有上皮的剥脱及各种混合性病变。" },
      ],
      dataList1: [
        { value: "0", name: "明亮，雪白，一过性、模糊、半透明的醋酸白色上皮。" },
        { value: "1", name: "明亮，白色程度较差，或间断呈白色。" },
        { value: "2", name: "污浊，呈牡蛎灰色，浓厚稍凸的醋酸白色上皮。" },
      ],
      dataList2: [
        { value: "0", name: "细点状或细小镶嵌。管径细小不规则，非扩张性血管环。毛细血管间距狭窄。" },
        { value: "1", name: "涂冰醋酸后未见血管表现。" },
        { value: "2", name: "粗点状或大的镶嵌。个别血管扩张。毛细血管间距加宽。" },
      ],
      dataList3: [
        { value: "0", name: "整个宫颈染为暗棕色，前三项≤2分，而碘试验（－），为低度病变。" },
        { value: "1", name: "部分区域染为浅棕色，斑驳的龟背样表现" },
        { value: "2", name: "无染区表现，呈芥末黄色，前三项≥3分，而碘试验（－），为高度病变" },
      ],
      dataList4: [
        { value: "0", name: "无" },
        { value: "1", name: "较正常稍多" },
        { value: "2", name: "量多、无溢出" },
        { value: "3", name: "量多、有溢出" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ReidColposcopicIndex.vue